import Vue from 'vue';
import './assets/tailwind.css';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import { initializeApp } from 'firebase/app';

// import VueHtml2Canvas from 'vue-html2canvas';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faUser, faXmarkCircle, faCircleQuestion, faCircleCheck,
} from '@fortawesome/free-regular-svg-icons';
import {
  faTableColumns,
  faClipboard,
  faChartSimple,
  faChartLine,
  faBook,
  faPerson,
  faPersonChalkboard,
  faPeoplePulling,
  faBookOpen,
  faBars,
  faArrowLeft,
  faTriangleExclamation,
  faSpinner,
  faCaretDown,
  faRightFromBracket,
  faPlus,
  faFileExcel,
  faFileDownload,
  faCirclePlus,
  faCity,
  faTrophy,
  faEarthAsia,
  faStar,
  faCircleExclamation,
  faEye,
  faHouse,
  faUsers,
  faChevronRight,
  faChevronLeft,
  faFileExport,
  faArrowDownAZ,
  faArrowDownZA,
  faSquare,
  faSquareCheck,
  faShareFromSquare,
  faClipboardCheck,
  faCheckDouble,
  faCaretRight,
  faDatabase,
  faArrowRightToCity,
  faBookOpenReader,
  faBookAtlas,
  faClipboardQuestion,
  faXmark,
  faTrash,
  faPencil,
  faSave,
  faChevronUp,
} from '@fortawesome/free-solid-svg-icons';

import App from './App.vue';
import router from './router';
import store from './store';

/* add icons to the library */
library.add(faXmarkCircle);
library.add(faUser);
library.add(faTableColumns);
library.add(faClipboard);
library.add(faChartSimple);
library.add(faChartLine);
library.add(faBook);
library.add(faPerson);
library.add(faPersonChalkboard);
library.add(faPeoplePulling);
library.add(faBookOpen);
library.add(faCircleQuestion);
library.add(faBars);
library.add(faArrowLeft);
library.add(faTriangleExclamation);
library.add(faSpinner);
library.add(faCaretDown);
library.add(faRightFromBracket);
library.add(faPlus);
library.add(faFileExcel);
library.add(faFileDownload);
library.add(faCirclePlus);
library.add(faCircleCheck);
library.add(faCity);
library.add(faTrophy);
library.add(faEarthAsia);
library.add(faStar);
library.add(faCircleExclamation);
library.add(faEye);
library.add(faHouse);
library.add(faUsers);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faFileExport);
library.add(faArrowDownAZ);
library.add(faArrowDownZA);
library.add(faSquare);
library.add(faSquareCheck);
library.add(faShareFromSquare);
library.add(faClipboardCheck);
library.add(faCheckDouble);
library.add(faCaretRight);
library.add(faDatabase);
library.add(faArrowRightToCity);
library.add(faBookOpenReader);
library.add(faBookAtlas);
library.add(faClipboardQuestion);
library.add(faXmark);
library.add(faTrash);
library.add(faPencil);
library.add(faSave);
library.add(faChevronUp);

Vue.component('font-awesome-icon', FontAwesomeIcon);
// Vue.use(VueHtml2Canvas);

Vue.directive('click-outside', {
  // eslint-disable-next-line no-unused-vars
  bind(el, binding, vnode) {
    // eslint-disable-next-line no-param-reassign
    el.clickOutsideEvent = (event) => {
      // Check if click was outside the element
      if (!(el === event.target || el.contains(event.target))) {
        // Call the provided method
        binding.value(event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.config.productionTip = false;

delete Icon.Default.prototype.getIconUrl;
Icon.Default.mergeOptions({
  // eslint-disable-next-line global-require
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  // eslint-disable-next-line global-require
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // eslint-disable-next-line global-require
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const firebaseConfig = {
  apiKey: 'AIzaSyDAk_b8S1dN2wo4KL6vnlapixVo9cRlomQ',
  authDomain: 'wwf-plastic.firebaseapp.com',
  projectId: 'wwf-plastic',
  storageBucket: 'wwf-plastic.appspot.com',
  messagingSenderId: '695658218686',
  appId: '1:695658218686:web:b5cb7ec16711743f75caef',
  measurementId: 'G-WGVW7QCDPX',
};

initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
